import React, { Component } from 'react';
import $ from 'jquery';
import DatePicker from "react-datepicker";
import { Line, Pie } from 'react-chartjs-2';
import { Collapse } from 'react-collapse';
import Loader from 'react-loader-spinner';


class NlpUsage extends Component {
    constructor() {
        super();
        this.state = {
            selectedDate: new Date(),
            noOfTodayApiUsage: null,
            last7DayApiUsage: null,
            noOfLast30DayApiUsage: null,
            displayUsageByLang: true,
            displayUsageByHour: true,
            showLoader: false,

            usageByHourData: {
                labels: [],
                datasets: [{
                    data: [],
                    label: "# of Api Usages",
                    borderColor: "#3BA4DC",
                    pointColor: "#fff",
                    responsive: true,
                    pointStrokeColor: "#ccc",
                    pointHoverRadius: 10,
                    backgroundColor: ["rgba(60,167,224,0.4)"],
                    fill: true
                }]
            },
            usageByLanguage: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [
                            'rgb(110, 125, 171)',
                            'rgb(156, 222, 159)',
                            'rgb(255, 102, 102)',
                            'rgb(14, 177, 210)',
                            'rgb(106, 57, 55)',
                            'rgb(204, 255, 102)',
                            'rgb(247, 160, 114)',
                            'rgb(191, 181, 175)',
                            'rgb(244, 255, 82)',
                            'rgb(95, 80, 107)',
                            'rgb(105, 255, 241)',
                            'rgb(155, 136, 22)',
                            'rgb(242, 100, 25)'
                        ]

                    }
                ]
            },

        }
    }

    resetDate = () => {
        this.onDateChange(new Date());
    }

    refreshData = (id) => {
        var longDate = new Date(this.state.selectedDate.toDateString()).getTime();
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.loadLanguageStat(longDate)
        this.loadApiUsageStat(longDate)
    }

    componentDidMount() {
        var longDate = new Date(this.state.selectedDate.toDateString()).getTime();
        this.setState({ selectedDate: longDate })
        setTimeout(() => {
            this.loadUsageRecordData(longDate)
            this.loadLanguageStat(longDate)
            this.loadApiUsageStat(longDate)
        }, 300);

        var dailyApiUsageController = this;
        document.addEventListener("projectChanged", function (event) {
            var longDate = new Date(dailyApiUsageController.state.selectedDate.toDateString()).getTime();
            dailyApiUsageController.setState({ selectedDate: longDate })
            dailyApiUsageController.loadUsageRecordData(longDate);
            dailyApiUsageController.loadLanguageStat(longDate);
            dailyApiUsageController.loadApiUsageStat(longDate)
        });
    }

    loadUsageRecordData = () => {
        var StatisticsController = this;
        $.ajax({
            url: "/api/no-of-api-usage-data",
            async: false,
            method: 'GET',
            data: {
                projectId: localStorage.getItem("currentProjectId"),
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                apiType: 'NLP_API'
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    StatisticsController.state.noOfTodayApiUsage = res.result.noOfTodayApiUsage;
                    StatisticsController.state.last7DayApiUsage = res.result.last7DayApiUsage;
                    StatisticsController.state.noOfLast30DayApiUsage = res.result.noOfLast30DayApiUsage;
                    StatisticsController.state.showLoader = true;
                    StatisticsController.setState(StatisticsController.state);
                }
            }
        });
    }


    loadLanguageStat = (longDate) => {
        var DailyUsageController = this;
        $.ajax({
            url: "/api/api-usage-language-stat",
            async: false,
            method: 'GET',
            data: {
                projectId: localStorage.getItem("currentProjectId"),
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                apitype: 'NLP_API',
                date: longDate,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },

            success: function (res) {
                DailyUsageController.state.usageByLanguage.labels = [];
                DailyUsageController.state.usageByLanguage.datasets[0].data = [];
                if (res.success === true && res.result.length !== 0) {
                    for (var i = 0; i < res.result.length; i++) {
                        DailyUsageController.state.usageByLanguage.labels.push(res.result[i].key);
                        DailyUsageController.state.usageByLanguage.datasets[0].data.push(res.result[i].value);
                    }
                    DailyUsageController.state.showLoader = true;
                    DailyUsageController.setState(DailyUsageController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    loadApiUsageStat = (longDate) => {
        var DailyUsageStatController = this;
        $.ajax({
            url: "/api/api-usage-stat",
            async: false,
            method: 'GET',
            data: {
                projectId: localStorage.getItem("currentProjectId"),
                date: longDate,
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                apiType: 'NLP_API'
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },

            success: function (res) {
                DailyUsageStatController.state.usageByHourData["datasets"][0].data = [];
                DailyUsageStatController.state.usageByHourData["labels"] = [];
                if (res.success === true && res.result.length !== 0) {
                    var dataSetDataAndLabel = DailyUsageStatController.setDailyConvLabels(res.result);
                    DailyUsageStatController.state.usageByHourData["datasets"][0].data = dataSetDataAndLabel.datasetData;
                    DailyUsageStatController.state.usageByHourData["labels"] = dataSetDataAndLabel.labelData;

                    var totalNoOfData = 0
                    for (var i = 0; i < res.result.length; i++) {
                        var valueToInt = parseInt(res.result[i].value)
                        totalNoOfData += valueToInt;
                    }
                    DailyUsageStatController.state.totalNoOfData = totalNoOfData
                    DailyUsageStatController.state.showLoader = true;
                    DailyUsageStatController.setState(DailyUsageStatController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    setDailyConvLabels = (data) => {
        var DailyConvController = this;
        var labelData = [];
        var datasetData = [];
        for (var i = 0; i < data.length; i++) {
            if (data[i].key < "12") {
                if (data[i].key == "00") {
                    labelData.push("12 AM - 1 AM");
                } else {
                    if (data[i].key == "11") {
                        labelData.push(Number(data[i].key) + " AM"
                            + " - " + (Number(data[i].key) + 1) + " PM");
                    } else {
                        labelData.push(Number(data[i].key) + " AM"
                            + " - " + (Number(data[i].key) + 1) + " AM");
                    }
                }
            } else {
                if (data[i].key == "12") {
                    labelData.push(Number(data[i].key) + " PM"
                        + " - " + ((Number(data[i].key) - 12) + 1) + " PM");
                } else {
                    if (data[i].key == "23") {
                        labelData.push((Number(data[i].key) - 12) + " PM"
                            + " - " + ((Number(data[i].key) - 12) + 1) + " AM");
                    } else {
                        labelData.push((Number(data[i].key) - 12) + " PM"
                            + " - " + ((Number(data[i].key) - 12) + 1) + " PM");
                    }
                }
            }
            datasetData.push(data[i].value);
        }
        return { "datasetData": datasetData, "labelData": labelData };

    }

    onDateChange = (date) => {
        this.state.selectedDate = date;
        this.setState(this.state);
        var longDate = new Date(date.toDateString()).getTime();
        this.loadLanguageStat(longDate);
        this.loadApiUsageStat(longDate);
    }

    displayUsageByLang = () => {
        this.state.displayUsageByLang ? this.setState({ displayUsageByLang: false }) :
            this.setState({ displayUsageByLang: true });
    }

    displayUsageByHour = () => {
        this.state.displayUsageByHour ? this.setState({ displayUsageByHour: false }) :
            this.setState({ displayUsageByHour: true })
    }
    render() {
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!(this.state.showLoader)}
                    height={400}
                    width={50}
                    style={{ textAlign: 'center' }} />
                <div style={{ display: this.state.showLoader ? 'block' : 'none' }}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div class="row mt-4 mb-4">
                                    <div style={{
                                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                                        paddingLeft: "10px", fontSize: "13px", borderRadius: "9px"
                                    }}>
                                        <br />Daily<br />Api Usage<br /><br />
                                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.state.noOfTodayApiUsage}<br />
                                            <div style={{ fontSize: "10px" }}>Today</div>
                                        </div>
                                    </div>

                                    <div style={{
                                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                                    }}>
                                        <br />Weekly<br />Api Usage<br /><br />
                                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.state.last7DayApiUsage}<br />
                                            <div style={{ fontSize: "10px" }}>Last 7 Days</div>
                                        </div>
                                    </div>
                                    <div style={{
                                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                                    }}>
                                        <br />Monthly<br />Api Usage<br /><br />
                                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.state.noOfLast30DayApiUsage}<br />
                                            <div style={{ fontSize: "10px" }}>Last 30 Days</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-7" style={{ marginTop: '23px' }}>
                                <h6 className="nav-item" style={{ color: '#282a65' }}>Daily Api Usage Data</h6>
                            </div>
                            <div className="col-sm-5 p-0">
                                <div className="d-flex flex-row-reverse pt-2">
                                    <button className="btn action-button"
                                        style={{ marginTop: '0px' }}
                                        onClick={this.refreshData} title="Refresh">
                                        <img src="./assets/images/refresh_white_24dp.png" />
                                    </button>

                                    <button className="btn action-button"
                                        style={{ marginTop: '0px' }}
                                        onClick={this.resetDate}>Reset</button>

                                    <DatePicker
                                        id="date"
                                        selected={this.state.selectedDate}
                                        onChange={this.onDateChange}>
                                    </DatePicker>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <h6>
                                <img src={this.state.displayUsageByHour ? './assets/images/downward_arrow.png' :
                                    './assets/images/rightward_arrow.png'}
                                    onClick={this.displayUsageByHour} />Api Usage by Hour<br /><br />
                            </h6>
                            <div className="col-lg-12">
                                <Collapse isOpened={this.state.displayUsageByHour}>

                                    <div className="card filled-line-chart">
                                        <div className="card-body">
                                            <div className="position-relative mb-4">
                                                <Line data={this.state.usageByHourData} width={1000} height={200} />

                                            </div>
                                        </div>
                                    </div>
                                </Collapse>
                            </div>
                            <div className="col-lg-6">
                                <h6>
                                    <img src={this.state.displayUsageByLang ? './assets/images/downward_arrow.png' :
                                        './assets/images/rightward_arrow.png'}
                                        onClick={this.displayUsageByLang} />Api Usage by Language</h6><br />
                                <Collapse isOpened={this.state.displayUsageByLang}>
                                    <div className="card monthly-conversation-chart">
                                        <div className="card-body">
                                            <div className="chartHeight">
                                                <Pie data={this.state.usageByLanguage} />
                                            </div>
                                        </div>
                                    </div>
                                </Collapse>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
export default NlpUsage;


// WEBPACK FOOTER //
// ./src/nlpUi/NlpUsage.js